<h1 mat-dialog-title>
    <span [translate]="'dashboard.listeInfos.title'"></span>
    <span [mat-dialog-close]><i class="zmdi zmdi-close"></i></span>
</h1>
<div mat-dialog-content>
    <list-view [liste]="listeBackup" *ngIf="listeBackup"></list-view>
</div>